import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { ObjektStrukturTreetableComponent, ProgressDialogComponent } from './objekt-struktur-treetable.component';
import { DialogModule } from '../../@shared/dialog/dialog.module';
import { AddGebaeudeDialogModule } from './add-gebaeude-dialog/add-gebaeude-dialog.module';
import { AddSektionDialogModule } from './add-sektion-dialog/add-sektion-dialog.module';
import { AddRaumDialogModule } from './add-raum-dialog/add-raum-dialog.module';
import { AddIndicatorDialogModule } from './add-indicator-dialog/add-indicator-dialog.module';
import { EditIndicatorDialogModule } from './edit-indicator-dialog/edit-indicator-dialog.module';
import { EditGebaeudeDialogModule } from './edit-gebaeude-dialog/edit-gebaeude-dialog.module';
import { EditSektionDialogModule } from './edit-sektion-dialog/edit-sektion-dialog.module';
import { EditRaumDialogModule } from './edit-raum-dialog/edit-raum-dialog.module';

@NgModule({
  declarations: [
    ObjektStrukturTreetableComponent,
    ProgressDialogComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatTooltipModule,
    DragDropModule,
    DialogModule,
    AddGebaeudeDialogModule,
    AddSektionDialogModule,
    AddRaumDialogModule,
    AddIndicatorDialogModule,
    EditGebaeudeDialogModule,
    EditSektionDialogModule,
    EditRaumDialogModule,
    EditIndicatorDialogModule
  ],
  exports: [
    ObjektStrukturTreetableComponent
  ],
  providers: []
})
export class ObjektStrukturTreetableModule { }
